import GameParameterInterface from '@/models/game/parameters/interface'

interface BarrelLotteryParameter {
  maxSwordCount: number,
  swordCount: number,
  prize: BarrelGamePrize
}

interface BarrelGamePrize {
  prizeImage: string
}

export default class BarrelParameter implements GameParameterInterface {
  constructor(private parameter: BarrelLotteryParameter) { }

  createSetOption(): BarrelLotteryParameter {
    return {
      maxSwordCount: this.parameter.maxSwordCount,
      swordCount: this.parameter.swordCount,
      prize: this.parameter.prize,
    }
  }

  get guideUrl(): string {
    return ''
  }
}
